import jquery from "jquery";
window.$ = window.jQuery = jquery;
import Helpers from "../base/Helpers";

function shouldShowBanner(id) {
  if (sessionStorage.getItem("banner-" + id) !== "no") {
    return true;
  }
  return false;
}

if (document.querySelector(".announcement-banner__counter")) {
  $(".js-countdown-timer-announcement").each(function () {
    var languages = {
      days: window.languages.bannerDaysLeft,
      hours: window.languages.bannerHoursLeft,
      minutes: window.languages.bannerMinutesLeft,
      seconds: window.languages.bannerSecondsLeft,
    }

    var $this = $(this);
    var id = $this.parents(".announcement-banner__counter").data("id");
    if (!shouldShowBanner(id)) {
      return;
    }
    var countWrapperDiv = $("<div>").addClass("info-banner__counter--wrapper");

    var daysDiv = $("<div>").addClass("info-banner__counter--item");
    var hoursDiv = $("<div>").addClass("info-banner__counter--item");
    var minutesDiv = $("<div>").addClass("info-banner__counter--item");
    var secondsDiv = $("<div>").addClass("info-banner__counter--item");

    var daysSpanText = $("<div>");
    var hoursSpanText = $("<div>");
    var minutesSpanText = $("<div>");
    var secondsSpanText = $("<div>");

    var daysSpanNumber = $("<div>");
    var hoursSpanNumber = $("<div>");
    var minutesSpanNumber = $("<div>");
    var secondsSpanNumber = $("<div>");
  
    $this.before(countWrapperDiv);

    countWrapperDiv.append(daysDiv);
    daysDiv.append(daysSpanNumber);
    daysDiv.append(daysSpanText);

    countWrapperDiv.append(hoursDiv);
    hoursDiv.append(hoursSpanNumber);
    hoursDiv.append(hoursSpanText);

    countWrapperDiv.append(minutesDiv);
    minutesDiv.append(minutesSpanNumber);
    minutesDiv.append(minutesSpanText);

    countWrapperDiv.append(secondsDiv);
    secondsDiv.append(secondsSpanNumber);
    secondsDiv.append(secondsSpanText);

    // Set the date we're counting down to
    var countDownDateStart = $this.data("date-start") ? new Date($this.data("date-start")).getTime() : null;
    var countDownDateEnd = new Date($this.data("date-end")).getTime();

    function shouldHideCountdown(now, startDate) {
      return startDate !== null && now <= startDate;
    }

    // Update the count down every 1 second
    var x = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();

      // Show countdown on countDownDateStart
      if (shouldHideCountdown(now, countDownDateStart)) {
        $this.parents(".announcement-banner__counter").css("opacity", "0");
        $this.parents(".announcement-banner__counter").addClass("hidden");
        return;
      }

      // Find the distance between now and the count down date
      var distance = countDownDateEnd - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (days > 0) {
        daysSpanText.text(days == 1 ? languages.days.one : languages.days.other);
        daysSpanNumber.text(days);
      } else {
        daysDiv.remove();
      }

      if (hours > 0 || days > 0) {
        hoursSpanText.text(hours == 1 ? languages.hours.one : languages.hours.other);
        hoursSpanNumber.text(hours);
      } else {
        hoursDiv.remove();
      }

      minutesSpanText.text(minutes == 1 ? languages.minutes.one : languages.minutes.other);
      minutesSpanNumber.text(minutes);
      secondsSpanText.text(seconds == 1 ? languages.seconds.one : languages.seconds.other);
      secondsSpanNumber.text(seconds);

      // If the count down is finished, write some text
      if (distance <= 0) {
        clearInterval(x);
        var id = $this.parents(".announcement-banner__counter").data("id");
        Helpers.setBannerShouldShow(id, false);
        $this.parents(".announcement-banner__counter").css("opacity", "0");
        $this.parents(".announcement-banner__counter").addClass("hidden");
        $this.css("opacity", "0");
      } else {
        $this.parents(".announcement-banner__counter").css("opacity", "1");
        $this.parents(".announcement-banner__counter").removeClass("hidden");
      }
      $(".announcement-banner__counter .icon-close").on("click", function () {
        clearInterval(x);
        var id = $this.parents(".announcement-banner__counter").data("id");
        Helpers.setBannerShouldShow(id, false);
          $this.parents(".announcement-banner__counter").css("opacity", "0");
          $this.parents(".announcement-banner__counter").addClass("hidden");
          $this.css("opacity", "0");
      });
    }, 1000);
  });
}


$(".js-countdown-timer").each(function () {
  var languages = {
    days: window.languages.bannerDaysLeft,
    hours: window.languages.bannerHoursLeft,
    minutes: window.languages.bannerMinutesLeft,
    seconds: window.languages.bannerSecondsLeft,
  }

  var $this = $(this);
  var id = $this.parents(".info-banner__counter").data("id");
  if (!shouldShowBanner(id)) {
    return;
  }
  var countWrapperDiv = $("<div>").addClass("info-banner__counter--wrapper");

  var daysDiv = $("<div>").addClass("info-banner__counter--item");
  var hoursDiv = $("<div>").addClass("info-banner__counter--item");
  var minutesDiv = $("<div>").addClass("info-banner__counter--item");
  var secondsDiv = $("<div>").addClass("info-banner__counter--item");

  var daysSpanText = $("<div>");
  var hoursSpanText = $("<div>");
  var minutesSpanText = $("<div>");
  var secondsSpanText = $("<div>");

  var daysSpanNumber = $("<div>");
  var hoursSpanNumber = $("<div>");
  var minutesSpanNumber = $("<div>");
  var secondsSpanNumber = $("<div>");
  
  $this.before(countWrapperDiv);

  countWrapperDiv.append(daysDiv);
  daysDiv.append(daysSpanNumber);
  daysDiv.append(daysSpanText);

  countWrapperDiv.append(hoursDiv);
  hoursDiv.append(hoursSpanNumber);
  hoursDiv.append(hoursSpanText);

  countWrapperDiv.append(minutesDiv);
  minutesDiv.append(minutesSpanNumber);
  minutesDiv.append(minutesSpanText);

  countWrapperDiv.append(secondsDiv);
  secondsDiv.append(secondsSpanNumber);
  secondsDiv.append(secondsSpanText);

  // Set the date we're counting down to
  var countDownDate = new Date($this.data("date")).getTime();

  // Update the count down every 1 second
  var x = setInterval(function () {
    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (days > 0) {
      daysSpanText.text(days == 1 ? languages.days.one : languages.days.other);
      daysSpanNumber.text(days);
    } else {
      daysDiv.remove();
    }

    if (hours > 0 || days > 0) {
      hoursSpanText.text(hours == 1 ? languages.hours.one : languages.hours.other);
      hoursSpanNumber.text(hours);
    } else {
      hoursDiv.remove();
    }

    minutesSpanText.text(minutes == 1 ? languages.minutes.one : languages.minutes.other);
    minutesSpanNumber.text(minutes);
    secondsSpanText.text(seconds == 1 ? languages.seconds.one : languages.seconds.other);
    secondsSpanNumber.text(seconds);

    // If the count down is finished, write some text
    if (distance <= 0) {
      clearInterval(x);
      var id = $this.parents(".info-banner__counter").data("id");
      Helpers.setBannerShouldShow(id, false);
      $this.parents(".info-banner__counter").css("opacity", "0");
      $this.parents(".info-banner__counter").addClass("hidden");
      $this.css("opacity", "0");
    } else {
      $this.parents(".info-banner__counter").css("opacity", "1");
      $this.parents(".info-banner__counter").removeClass("hidden");
    }
    $(".info-banner__counter .icon-close").on("click", function () {
      clearInterval(x);
      var id = $this.parents(".info-banner__counter").data("id");
      Helpers.setBannerShouldShow(id, false);
        $this.parents(".info-banner__counter").css("opacity", "0");
        $this.parents(".info-banner__counter").addClass("hidden");
        $this.css("opacity", "0");
    });
  }, 1000);
});

/**
 *
 * Notifications for discounts or marketing
 * See header.liquid
 * They use different triggers such as paramter or discount cookie
 */

$(".js-info-banner .icon-close").on("click", function () {
  var $this = $(this);
  $this.parents(".js-info-banner").addClass("hidden");
  var id = $this.parents(".js-info-banner").data("id");
  Helpers.setBannerShouldShow(id, false);
});

$(".js-info-banner, .js-announcement-banner").each(function () {
  var $this = $(this);
  var trigger = $this.data("trigger");
  var value = $this.data("value");
  var discount = Helpers.getCookie("discount_code");
  var id = $this.data("id");
  if (!shouldShowBanner(id)) {
    return;
  }
  if (trigger) {
    if (trigger === "static") {
      $this.css("opacity", "1");
      setTimeout(function () {
        $this.removeClass("hidden");
      },500);
    
    } else if (trigger === "discount-gold-club") {
      checkGoldClubCookie().then(function (discountCode) {
        if (discountCode) {
          $this.removeClass("hidden");
          setTimeout(function () {
            $this.css("opacity", "1");
          }, 500);
        }
      });
    } else if (trigger === "discount") {
      Helpers.getDiscount().then(function (discountCode) {
        if (discountCode && discountCode.substring(0, 2).toLowerCase() !== "gc") {
          $this.find(".text").html(
            $this
              .find(".text")
              .text()
              .replace("{{DISCOUNT}}", "<b>" + discountCode + "</b>")
          );
         
          $this.css("opacity", "1");
          setTimeout(function () {
            $this.removeClass("hidden");
          },500);
   
          if ($this.data("hide")) {
            setTimeout(function () { 
              $this.css("opacity", "0");
              $this.addClass("hidden");
              Helpers.setBannerShouldShow($this.data("id"), false);
            },$this.data("hide"));
          }
        
        }
      });
    } else if (trigger === "discount-gift") {
      Helpers.getDiscount().then(function (discountCode) {
        if (discountCode && discountCode.indexOf(value) != -1) {
          $this.find(".text").html(
            $this
              .find(".text")
              .text()
              .replace("{{DISCOUNT}}", "<b>" + discountCode + "</b>")
          );
          $this.css("opacity", "1");
          setTimeout(function () {
            $this.removeClass("hidden");
          },500);
        }
      });
    } else if (trigger === "no-discount") {
      if (!discount) {
        $this.css("opacity", "1");
       
        setTimeout(function () {
          $this.removeClass("hidden");
        }, 500);
      }
    } else if (
      window.location.pathname === trigger ||
      window.location.search.indexOf(trigger) != -1
    ) {
      $this.css("opacity", "1");
     
      setTimeout(function () {
        $this.removeClass("hidden");
      },500);
    }
  } else {
    $this.css("opacity", "1");
    setTimeout(function () {
      $this.removeClass("hidden");
    }, 500);
  }
});
